module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    staticClass: "password-rest-form"
  }, [_c('el-form-item', {
    staticClass: "password-field"
  }, [_c('password', {
    staticClass: "password",
    attrs: {
      "placeholder": "Enter new password",
      "id": "new-password"
    },
    model: {
      value: (_vm.newPassword),
      callback: function($$v) {
        _vm.newPassword = $$v
      },
      expression: "newPassword"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "hint"
  }, [_vm._v("Minimum 8 Characters")])], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "password-field"
  }, [_c('password', {
    staticClass: "password-reset-form",
    attrs: {
      "placeholder": "Confirm new password",
      "id": "confirm-password"
    },
    model: {
      value: (_vm.confirmedPassword),
      callback: function($$v) {
        _vm.confirmedPassword = $$v
      },
      expression: "confirmedPassword"
    }
  })], 1), _vm._v(" "), _c('el-button', {
    staticClass: "password-reset-btn",
    attrs: {
      "type": "primary",
      "disabled": _vm.isDisabled
    },
    on: {
      "click": _vm.onResetPassword
    }
  }, [_vm._v("Reset password")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-677e5acf","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/auth/PasswordOnlyResetFormOnUserList.vue
// module id = 3317
// module chunks = 3